export class ActivityEntity {}
